import {
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from "@/components/ui/sidebar";
import { useOrganization } from "@/contexts/frontend/organization/useOrganization";
import { NavLink, useLocation, useResolvedPath } from "react-router";
import {
    RESOURCE_ROUTES,
    type FrontendRoute,
    isRouteVisible,
} from "../frontend-routes";
import { isRouteActive } from "../route-matching";

function NavResourceItem({ route }: { route: FrontendRoute }) {
    const location = useLocation();
    const resolved = useResolvedPath(route.path);
    const { isMobile, setOpenMobile } = useSidebar();

    const isActive = isRouteActive(route, resolved.pathname, location);

    const handleClick = () => {
        if (isMobile) setOpenMobile(false);
        route.onClick?.();
    };

    if (route.onClick) {
        return (
            <SidebarMenuItem>
                <SidebarMenuButton
                    tooltip={route.name}
                    className="transition-colors duration-150"
                    onClick={() => handleClick()}
                >
                    <route.icon className="size-4 shrink-0" />
                    <span className="truncate">{route.name}</span>
                </SidebarMenuButton>
            </SidebarMenuItem>
        );
    }

    if (route.isExternal && route.href) {
        return (
            <SidebarMenuItem>
                <SidebarMenuButton
                    tooltip={route.name}
                    className="transition-colors duration-150"
                    render={
                        <a
                            href={route.href}
                            target="_blank"
                            rel="noopener noreferrer"
                        />
                    }
                >
                    <route.icon className="size-4 shrink-0" />
                    <span className="truncate">{route.name}</span>
                </SidebarMenuButton>
            </SidebarMenuItem>
        );
    }

    const to = route.searchParams
        ? {
              pathname: route.path,
              search: new URLSearchParams(route.searchParams).toString(),
          }
        : route.path;

    return (
        <SidebarMenuItem>
            <SidebarMenuButton
                isActive={isActive}
                tooltip={route.name}
                className="transition-colors duration-150"
                onClick={handleClick}
                render={<NavLink to={to} />}
            >
                <route.icon className="size-4 shrink-0" />
                <span className="truncate">{route.name}</span>
            </SidebarMenuButton>
        </SidebarMenuItem>
    );
}

export function NavResources() {
    const { settings } = useOrganization();

    return (
        <SidebarGroup>
            <SidebarGroupLabel>Resources</SidebarGroupLabel>
            <SidebarGroupContent>
                <SidebarMenu>
                    {RESOURCE_ROUTES.filter((route) =>
                        isRouteVisible(route, settings)
                    ).map((route) => (
                        <NavResourceItem key={route.name} route={route} />
                    ))}
                </SidebarMenu>
            </SidebarGroupContent>
        </SidebarGroup>
    );
}
